import { BaseService } from './baseservice';

class AlteryxServiceClass extends BaseService {
    async load(body) {
        var order = (body.order)?'asc':'desc';
        const url = '/alteryx/list/' + body.sortBy + "/" + order ;

        const response = await this.fetch('GET', url, body);

        if (response && response.data) {
            return response.data.data;
        }

        return [];
    }

    async uploadCSV(body, importType) {
        const url = '/alteryx/csv/' + importType;

        const response = await this.fetch('POST', url, body, 'multipart/form-data');

        if (response && response.data) {
            return response.data;
        }

        return [];
    }

    async getEmails(){
        const url = '/alteryx/emails';

        const response = await this.fetch('GET', url);

        if (response && response) {
            return response.data.data;
        }

        return [];
    }


    async getEmailsAllowed(){
        const url = '/alteryx/emails_allowed';

        const response = await this.fetch('GET', url);

        if (response && response) {
            return response.data.data;
        }

        return [];
    }

    async updateEmails(body) {
        const url = '/alteryx/emails';

        const response = await this.fetch('PUT', url, body);

        if (response && response.data) {
            return response.data;
        }

        return [];
    }

    async updateEmailsAllowed(body) {
        const url = '/alteryx/emails_allowed';

        const response = await this.fetch('PUT', url, body);

        if (response && response.data) {
            return response.data;
        }

        return [];
    }

    async isAllowed(){
        const url = '/alteryx/allowed';

        const response = await this.fetch('GET', url);

        if (response && response.data) {
            return response.data;
        }
    }

    async export() {
        const url = '/alteryx/export/list' ;

        const response = await this.fetch('GET', url);

        if (response && response.data) {
            return response.data.data;
        }

        return [];
    }
}

let AlteryxService = new AlteryxServiceClass(ENVIRONMENT.API_HOST);
export default AlteryxService;
